<template>
  <div class="quick-register-success">
    <div class="header-section">
      <div class="icon-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          fill="currentColor"
          class="bi bi-check-circle-fill"
          viewBox="0 0 16 16"
        >
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
          />
        </svg>
      </div>
      <h1 class="main-title">
        <span class="highlight">Parabéns!</span> Cadastro concluído
      </h1>
      <p class="subtitle">Seu acesso já está liberado e seu trial está ativo.</p>
    </div>

    <section class="content-section">
      <p class="success-message">
        {{ authStore.name || 'Bem-vindo' }}, seu cadastro foi concluído com sucesso!
      </p>

      <div class="trial-info">
        <p class="trial-title">
          <i class="bi bi-gift-fill me-2"></i>
          <strong>Seu teste grátis de 3 dias já está ativo</strong>
        </p>
        <p class="trial-text">
          Após o período de teste, sua assinatura será renovada automaticamente por <strong>R$ 97,00/mês</strong>.
          Você pode cancelar a qualquer momento.
        </p>
      </div>

      <p class="cta-text">
        Clique abaixo para acessar sua nova plataforma de ofertas abaixo da FIPE!
      </p>

      <div class="button-container">
        <button type="button" class="btn btn-submit" @click="handleAccess">
          COMEÇAR A USAR
        </button>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();
const router = useRouter();

const handleAccess = () => {
  router.push("/");
};
</script>

<style scoped>
.quick-register-success {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 2rem 1rem;
}

.quick-register-success > * {
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
}

.header-section {
  text-align: center;
  margin-bottom: 2.5rem;
  background: #16161d;
  padding: 2rem 1.5rem;
  border-radius: 12px;
}

.icon-container {
  margin-bottom: 1.5rem;
}

.bi-check-circle-fill {
  color: #a6c715;
}

.main-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #fff;
}

.main-title .highlight {
  color: #a6c715;
}

.subtitle {
  font-size: 0.95rem;
  color: #fff;
  margin: 0;
}

.content-section {
  background: #ffffff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.success-message {
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 2rem;
  color: #1a1a1a;
  line-height: 1.5;
}

.trial-info {
  background: rgba(166, 199, 21, 0.1);
  border: 2px solid #a6c715;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.trial-title {
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 0.75rem;
  color: #1a1a1a;
}

.trial-title strong {
  color: #6b8012;
}

.trial-title i {
  color: #a6c715;
}

.trial-text {
  font-size: 0.9rem;
  text-align: center;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

.trial-text strong {
  color: #1a1a1a;
  font-weight: 600;
}

.cta-text {
  font-size: 1rem;
  text-align: center;
  color: #333;
  margin-bottom: 2rem;
  line-height: 1.5;
}

.button-container {
  display: flex;
  justify-content: center;
}

.btn-submit {
  background: #a6c715;
  color: #16161d;
  font-weight: 700;
  font-size: 1.2rem;
  padding: 1.25rem 3rem;
  border: none;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.btn-submit:hover {
  background: #8fa612;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(166, 199, 21, 0.4);
}

@media (max-width: 768px) {
  .quick-register-success {
    padding: 1rem 0.5rem;
  }

  .header-section {
    padding: 1.5rem 1rem;
  }

  .content-section {
    padding: 1.5rem 1rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .success-message {
    font-size: 1.1rem;
  }

  .btn-submit {
    font-size: 1rem;
    padding: 1rem 2rem;
    width: 100%;
  }
}

/* Breakpoint para telas muito pequenas (≤479px) */
@media (max-width: 479px) {
  .quick-register-success {
    padding: 0.75rem 0.5rem;
  }
}
</style>
